import './RoleStageEligibility.scss';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Loader from 'components/atoms/Loader/Loader';
import TestIntro from 'components/organisms/TestIntro/TestIntro';
import { appSwitchRoutes } from 'constants/routes';
import { SupportedLocale, TestStatus, useUserQuery } from 'generated/graphql';
import config from 'views/Test/TestInfo/TestInfo.constants';
import RoleStageEligibilityLayout from './RoleStageEligibilityLayout';
import { useEligibilityStage } from './useEligibilityStage';

// What the eligibility stage is and how it is judged; "Start now" moves on to
// the questions themselves.
const RoleStageEligibilityIntro: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { roleId, stageId, role, stage, loading, backUrl } =
    useEligibilityStage();

  const userQueryResponse = useUserQuery();
  const assessmentLocale =
    userQueryResponse.data?.User.preferredLocale.locale ||
    SupportedLocale.English;

  if (loading || !role || !stage) {
    return <Loader isOverlay />;
  }

  const introConfig = config['eligibility']({});

  return (
    <RoleStageEligibilityLayout
      role={role}
      pageTitle={stage.name}
      backUrl={backUrl}
    >
      <TestIntro
        MainIcon={introConfig.icon}
        title={introConfig.title}
        notes={introConfig.notes}
        assessmentLocale={assessmentLocale}
        testStatus={TestStatus.NotStarted}
        hasPractice={false}
        onStart={() =>
          navigate(
            appSwitchRoutes.roleStageEligibilityQuestions.getUrl(
              roleId,
              stageId
            )
          )
        }
        testTimePerQuestion={0}
        primaryButtonText={t('test.instructions.eligibility.startNow')}
      />
    </RoleStageEligibilityLayout>
  );
};

export default RoleStageEligibilityIntro;
